import { Star } from "lucide-react";
import "./advisorfeedback.css";

export default function AnalyticsAdvisorFeedback() {
  return (
    <div className="rf-analytics-feedback-card">

      <h3 className="rf-analytics-feedback-title">
        Advisor Feedback
      </h3>

      {/* RATING */}
      <div className="rf-analytics-feedback-rating">
        <span className="rf-analytics-feedback-label">
          Lead Quality Score
        </span>

        <div className="rf-analytics-feedback-stars">
          {[1,2,3,4,5].map((i) => (
            <Star key={i} size={16} fill="#facc15" stroke="#facc15" />
          ))}
        </div>
      </div>

      {/* PROGRESS */}
      <div className="rf-analytics-feedback-progress">
        <div
          className="rf-analytics-feedback-progress-fill"
          style={{ width: "88%" }}
        />
      </div>

      {/* TEXT */}
      <p className="rf-analytics-feedback-text">
        “Highly qualified leads with clear financial goals.
        Excellent communication and consistent conversions.”
      </p>

      {/* ADVISOR */}
      <span className="rf-analytics-feedback-advisor">
        — Rajesh Kumar, Senior Advisor
      </span>

    </div>
  );
}
